export default function StandardsFrameworkSection() {
  const standards = [
    'ASME Boiler and Pressure Vessel Code (Sections II, V, VIII, IX)',
    'ISO 3834 – Quality Requirements for Fusion Welding (reference framework)',
    'ISO 12944 – Corrosion Protection of Steel Structures',
    'EN 13445 – Unfired Pressure Vessels',
    'EN 10204 – Metallic Products Types of Inspection Documents',
    'NORSOK M-501 – Surface Preparation and Protective Coating',
    'AWS D1.1 – Structural Welding Code Steel',
    'PED 2014/68/EU – Pressure Equipment Directive',
  ];

  return (
    <section className="py-28 px-8 bg-dark-primary">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-industrial-lighter/20 rounded-full mb-6">
            <span className="text-industrial-lighter text-xs font-medium tracking-[0.12em] uppercase">
              Standards Framework
            </span>
          </div>
          <h2 className="font-serif text-white text-4xl leading-tight mb-6">
            Applicable Standards and Codes
          </h2>
          <p className="text-industrial-light text-base leading-[1.8] max-w-3xl">
            Verification activities reference internationally recognized standards and client-approved specifications. Services do not constitute certification or approval authority.
          </p>
        </div>

        {/* Standards List */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {standards.map((standard) => (
            <div key={standard} className="flex items-start gap-4 bg-dark-card/40 border border-dark-border/30 rounded-lg p-6">
              <div className="w-1.5 h-1.5 rounded-full bg-industrial-light mt-2.5 flex-shrink-0"></div>
              <span className="text-industrial-light text-sm leading-[1.75]">
                {standard}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}